import * as React from "react";
import * as ReactDOM from "react-dom";
import { App } from "./modules/app";

import "typeface-roboto";
import "./style/main.css";
import { CONFIG } from "./config";
import { Amplify, Auth, Hub } from "aws-amplify";
import { Cookies } from "react-cookie";

Amplify.configure({
  API: {
    endpoints: [
      {
        endpoint: CONFIG.apiGateway.URL,
        name: "ApaqPortalAPI",
        region: CONFIG.apiGateway.REGION,
      },
      ...(CONFIG.cpcpV2ApiGateway ? [{
        endpoint: CONFIG.cpcpV2ApiGateway.URL,
        name: "CpcpV2API",
        region: CONFIG.cpcpV2ApiGateway.REGION,
      }] : []),
      ...(CONFIG.apaqPortalServiceGateway ? [{
        endpoint: CONFIG.apaqPortalServiceGateway.URL,
        name: "ApaqPortalServiceAPI",
        region: CONFIG.apaqPortalServiceGateway.REGION,
      }] : []),
    ],
  },
  Auth: {
    identityPoolId: CONFIG.cognito.IDENTITY_POOL_ID,
    mandatorySignIn: true,
    region: CONFIG.cognito.REGION,
    userPoolId: CONFIG.cognito.USER_POOL_ID,
    userPoolWebClientId: CONFIG.cognito.APP_CLIENT_ID,
    oauth: CONFIG.oauth
  },
});

const cookies = new Cookies();

Hub.listen('auth', ({payload: {event, data}}) => {
  switch (event) {
    case "signIn":
      Auth.currentAuthenticatedUser().then( (user) => {
        cookies.set("AUTH_USER", user.username)
      }).catch((e) => {
        console.log(`Failure to get auth user: ${e}`);
        window.location.href = '/error';
      });
      break;
    case "signIn_failure":
      console.log(`Sign in failed with error: ${data}`);
      window.location.href = '/error';
      break;
    case "cognitoHostedUI":
      break;
    default:
      console.log(`Unhandled event ${event} - data: ${JSON.stringify(data)}`);
      break;
  }
});

try {
  if (window.location.pathname != '/error') {
    await Auth.currentAuthenticatedUser();
  }
} catch (e) {
  console.log(`User not authenticated, attempting to authenticate user via Midway - ${e}`);
  window.location.href = '/sign-in';
}

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
